export default class FiltroCartaPropostaAguardandoAprovacao {
    constructor () {
        this.NumeroCartaProposta = undefined;
        this.TipoCarta = undefined;
        this.PeriodoDeEmissaoInicio = undefined;
        this.PeriodoDeEmissaoFim = undefined;
        this.EmpresasIds = undefined;
        this.EmpresaId = null;
        this.ClientesIds = undefined;
        this.StatusSolicitacao = undefined;
        this.RepresentanteId = undefined;
    }
}